import React from 'react';
import api from '../../../services/api';
import { Prefix } from '../../../services/prefix';
import { mutate as GlobalMutate } from 'swr';

export default function UpdateStatus({
  id,
  page,
  perPage,
  activeDefault,
  search,
}) {
  let pageExact = page + parseInt(1);

  function HandleStatus() {
    api
      .put(Prefix.replace(/[\\"]/g, '') + '/contract-managers/' + id, {
        active: activeDefault === 1 || activeDefault === true ? 0 : 1,
      })
      .then(() => {
        GlobalMutate(
          Prefix.replace(/[\\"]/g, '') +
            '/contract-managers?per_page=' +
            perPage +
            '&page=' +
            pageExact +
            '&search=' +
            search,
        );
      });
  }

  return (
    <>
      <label class="switch">
        <input
          type="checkbox"
          id={id + 'contract-managers'}
          onChange={HandleStatus}
          checked={activeDefault == 1 ? true : false}
        />
        <span class="slider round"></span>
      </label>
    </>
  );
}
